// this page is not in use . device installation is current page now.

import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Grid,
  // MenuItem,
  Typography,
  Autocomplete,
} from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
// import CustomSelect from "src/components/forms/theme-elements/CustomSelect";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import UsersService from "src/service/users";
import VehicleCategoryService from "src/service/vehicleCategory";
import WheelTypeService from "src/service/wheel";
import VehicleDetailsService from "src/service/vehicleDetails";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Add Vehicle Details ",
  },
];

const validationSchema = yup.object({
  agency_user_id: yup.string("agency name").required("agency name is required"),
  vehicle_category_id: yup
    .string("vehicle category number")
    .required("vehicle category number is required"),

  vehicle_wheel_id: yup
    .string("vehicle wheel type number")
    .required("vehicle wheel type number is required"),

  vehicle_no: yup
    .string("vehicle number")
    .min(10, "vehicle number should be of minimum 10 length")
    .max(10, "vehicle number should be of maximum 10 in length")
    .required("vehicle number is required"),

  make: yup
    .string("making year")
    .min(2, "makeing year should be of minimum 2 length")
    .max(30, "makeing year should be of maximum 30 in length")
    .required("making year is required"),

  model: yup
    .string("vehicle model")
    .min(2, "vehicle model should be of minimum 2 length")
    .max(30, "vehicle model should be of maximum 30 in length")
    .required("vehicle model is required"),
});

const AddVehicleDetails = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  // get drivers list
  const [agency, setAgency] = useState([]);
  const [vehicleCat, setVehicleCategory] = useState([]);
  const [wheel, setWheelType] = useState([]);

  const fetchVehicleData = async () => {
    try {
      // get agency
      const res = await UsersService.getUsers({});
      // get vehicle category
      const res2 = await VehicleCategoryService.getVehicleCategory({});
      // get wheel type
      const res3 = await WheelTypeService.getWheelType({});

      setAgency(res.data);
      setVehicleCategory(res2.data);
      setWheelType(res3.data);
    } catch (error) {
      console.log(error);
    }
  };

  const initialValues = {
    manufacturer_id: sessionData.data.id,
    distributor_id: sessionData.data.distributor_id,
    agency_user_id: "",
    vehicle_category_id: "",
    vehicle_wheel_id: "",
    vehicle_no: "",
    make: "",
    model: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));
        try {
          const res = await VehicleDetailsService.addVehicleDetails(values);

          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/vehicleDetailsLists");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  useEffect(() => {
    fetchVehicleData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  return (
    <div>
      <Breadcrumb title="Add Vehicle Details" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Add Vehicle Details
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/vehicleDetailsLists");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "5px" }}>
            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              <CustomFormLabel htmlFor="fs-agency">
                Agency Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="agency_user_id"
                name="agency_user_id"
                options={agency}
                getOptionLabel={(option) =>
                  option.agency_or_individual_user_name
                }
                value={
                  agency.find(
                    (option) => option.id === values.agency_user_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "agency_user_id",
                      value: newValue?.id || "",
                    },
                  });
                }}
                onBlur={handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={
                      touched.agency_user_id && Boolean(errors.agency_user_id)
                    }
                    helperText={touched.agency_user_id && errors.agency_user_id}
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select an agency"
                  />
                )}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              <CustomFormLabel htmlFor="fs-language">
                Vehicle Category <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="vehicle_category_id"
                name="vehicle_category_id"
                options={vehicleCat}
                getOptionLabel={(option) => option.vehicle_name}
                value={
                  vehicleCat.find(
                    (option) => option.id === values.vehicle_category_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "vehicle_category_id",
                      value: newValue?.id || "",
                    },
                  });
                }}
                onBlur={handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={
                      touched.vehicle_category_id &&
                      Boolean(errors.vehicle_category_id)
                    }
                    helperText={
                      touched.vehicle_category_id && errors.vehicle_category_id
                    }
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select a vehicle category"
                  />
                )}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              <CustomFormLabel htmlFor="fs-language">
                Vehicle Wheel Type <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="vehicle_wheel_id"
                name="vehicle_wheel_id"
                options={wheel}
                getOptionLabel={(option) => option.wheel_type}
                value={
                  wheel.find(
                    (option) => option.id === values.vehicle_wheel_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "vehicle_wheel_id",
                      value: newValue?.id || "",
                    },
                  });
                }}
                onBlur={handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={
                      touched.vehicle_wheel_id &&
                      Boolean(errors.vehicle_wheel_id)
                    }
                    helperText={
                      touched.vehicle_wheel_id && errors.vehicle_wheel_id
                    }
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select a wheel type"
                  />
                )}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              <CustomFormLabel htmlFor="vehicle_no">
                Vehicle Number <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="vehicle_no"
                name="vehicle_no"
                type="text"
                value={values.vehicle_no}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.vehicle_no && Boolean(errors.vehicle_no)}
                helperText={touched.vehicle_no && errors.vehicle_no}
                variant="outlined"
                placeholder="Enter Vehicle Number"
                fullWidth
              />
            </Grid>
            {/* <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="fs-language">Vehicle Number</CustomFormLabel>
                <CustomSelect id="driver_id" name="driver_id"
                  value={values.driver_id}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={
                    touched.driver_id && Boolean(errors.driver_id)
                  }
                  helperText={
                    touched.driver_id && errors.driver_id
                  }
                  fullWidth variant="outlined">
                  <MenuItem value=""> select </MenuItem>
                  {drivers.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.driver_name}
                    </MenuItem>
                  ))}
                </CustomSelect>
            </Grid> */}
            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              <CustomFormLabel htmlFor="make">
                Make Year <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="make"
                name="make"
                type="text"
                value={values.make}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.make && Boolean(errors.make)}
                helperText={touched.make && errors.make}
                variant="outlined"
                placeholder="Enter making year"
                fullWidth
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              <CustomFormLabel htmlFor="model">
                Vehicle Model <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="model"
                name="model"
                type="text"
                value={values.model}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.model && Boolean(errors.model)}
                helperText={touched.model && errors.model}
                variant="outlined"
                placeholder="Enter Vehicle model"
                fullWidth
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} sx={12}>
              <Button color="success" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default AddVehicleDetails;
